module.exports = __webpack_public_path__ + "static/sticky-cta-left-img-f093aec8557ee677d76c53815307caa6.png";